<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
        @submit="handleSubmit"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产编码">
              <a-input
                :disabled="true"
                v-decorator="[
                  'assetCode',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产类别">
              <a-select
                v-decorator="[
                  'categoryId',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                style="width: 100%"
                @change="categoryChange"
              >
                <a-select-option
                  v-for="item in assetsCategoryList"
                  :key="item.id"
                  :value="item.id"
                >
                  <div>
                    {{ item.subCategoryName }}
                  </div>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="品牌型号">
              <a-input
                v-decorator="[
                  'brandModel',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="采购日期">
              <a-date-picker
                format="YYYY-MM-DD"
                v-decorator="[
                  'procurementTime',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="采购价格(元)">
              <a-input-number
                style="width: 100%"
                :min="1"
                v-decorator="[
                  'purchasePrice',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产负责人">
              <EmployeeSelector
                @change="
                  (arr) => {
                    if (arr.length) {
                      selectedUser = arr[0];
                    } else {
                      selectedUser = {};
                    }
                  }
                "
                :value="selectedUser.name ? [selectedUser] : []"
              >
                <a-button block style="text-align: left">
                  <div v-if="selectedUser.name">
                    {{ selectedUser.name }}
                  </div>
                  <div v-else>&nbsp;</div>
                </a-button>
              </EmployeeSelector>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产位置(部门)">
              <a-select
                v-decorator="[
                  'deptId',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="财务编码">
              <a-input
                v-decorator="[
                  'financialCode',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="启用日期">
              <a-date-picker
                format="YYYY-MM-DD"
                v-decorator="[
                  'startTime',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产状态">
              <a-select
                :disabled="true"
                v-decorator="[
                  'status',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="报废方式">
              <a-select
                v-decorator="[
                  'scrapMethod',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option v-for="item in ['平均年限法']" :key="item" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="报废时限(月)">
              <a-input-number
                style="width: 100%"
                :min="1"
                v-decorator="[
                  'scrapLimitMonths',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="净残值率">
              <a-input-number
                style="width: 100%"
                :min="0"
                :max="1"
                v-decorator="[
                  'netSalvageRate',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="备注">
              <a-textarea
                v-decorator="[
                  'remark',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="center">
          <a-space>
            <a-button type="primary" html-type="submit" :loading="loading">保存</a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import request from "@/api/request";
import { mapGetters } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import organization from "@/mixins/organization";
function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset-category/list",
    data,
    method: "post",
  });
}
function edit(data) {
  return request({
    url: "/office-service/fixed-asset/update",
    data,
    method: "post",
  });
}
export default {
  mixins: [organization],
  name: "editFixedAssets",

  data() {
    return {
      assetsCategoryList: [],
      form: this.$form.createForm(this),
      loading: false,
      id: null,
      selectedUser: {},
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("fixed_asset_status");
    },
  },
  components: {
    EmployeeSelector,
  },
  mounted() {
    fetchList({
      pageNum: 1,
      pageSize: 10000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.assetsCategoryList = res.list;
      }
    });
    const { id } = this.$route.query;
    this.id = id;
    if (id) {
      this.loading = true;
      request({
        url: `/office-service/fixed-asset/get/${id}`,
        method: "get",
      })
        .then((res) => {
          this.form.setFieldsValue(res);
          this.selectedUser = {
            userId: res.responsiblePersonId,
            name: res.responsiblePersonName,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    categoryChange(value) {
      const category = this.assetsCategoryList.find((item) => item.id === value);
      this.form.setFieldsValue({
        scrapMethod: category.scrapMethod,
        scrapLimitMonths: category.scrapLimitMonths,
        netSalvageRate: category.netSalvageRate,
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;

          edit({
            ...values,
            id: this.id,
            responsiblePersonId: this.selectedUser.userId,
            responsiblePersonName: this.selectedUser.name,
            startTime: values.startTime ? moment(values.startTime).format("YYYY-MM-DD") : null,
            procurementTime: values.procurementTime ? moment(values.procurementTime).format("YYYY-MM-DD") : null,
            deptName: this.organizationList.find((item) => item.id === values.deptId).uniqueName,
          })
            .then(() => {
              this.form.resetFields();
              this.$close(this.$route.path);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.center {
  margin-top: 80px;
}
</style>
